import { useDispatch } from 'react-redux';
import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { flexKeepingImage as flexKeepingImagePath } from '@mews-commander/assets';
import { MewsImage } from '@mews/business-components';
import { Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { Widget } from '@mews-commander/dashboard/widgets';
import { showFlexkeepingApplication } from '../actions';

const imageHeight = '196px';

export const FlexkeepingWidget = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(showFlexkeepingApplication());
    };

    return (
        <Widget titleTextKey={TextKey.Marketplace}>
            <MewsImage
                src={flexKeepingImagePath}
                height={imageHeight}
                objectFit="contain"
                objectPosition="left top"
                shouldShowLoader
            />
            <LocalizedMinorHighlight textKey={TextKey.DashboardWidgetFlexkeepingHeaderText} />
            <LocalizedSmallParagraph textKey={TextKey.DashboardWidgetFlexkeepingText} />
            <div>
                <Button onClick={handleClick} data-test-id={DataTestId.DashboardWidgetFlexkeepingButton} type="submit">
                    <LocalizedText textKey={TextKey.DashboardWidgetFlexkeepingButtonText} />
                </Button>
            </div>
        </Widget>
    );
};
